import { useBoundStore } from '~/src/store';

const useMode = () => useBoundStore((store) => store.mode);
const useSetMode = () => useBoundStore((store) => store.setMode);

export { useMode, useSetMode };
